import { FilterDto, FilterType } from '../../../types/FilterDto';
import type { TFunction } from "i18next";
import { LoadStateEnum } from '../types/enums';


export const getFiltersSurveyImport = async (t: TFunction<[string], undefined>): Promise<FilterDto[]> => {


    const staticFilters: FilterDto[] = [
        
        {
            name: 'State',
            description: t("survey:load.filterStatus"),
            type: FilterType.MULTIPLE,
            values: Object.keys(LoadStateEnum)
                .filter((key) => isNaN(Number(key)))
                .map((value) => ({
                    key: LoadStateEnum[value as keyof typeof LoadStateEnum],
                    value: t(`survey:statusType.${value}`)
                }))
        } 
    ];

    return [...staticFilters ];
};
